module.exports = __webpack_public_path__ + "img/card6.c1c02bad.png";